












/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'WorkflowStatusColorPicker',

  props: {
    color: {
      type: String,
      required: true,
    },
    colorSizeInPixels: {
      type: Number,
      default: 20,
    },
  },

  data() {
    return {
      ColorAssistant,
    }
  },
})
